import * as api from './api'
import * as reducers from './slice-reducers'
import { AppDispatch } from 'src/app/store'
import { updateCTCookie } from 'src/core/helpers'
import { Company, Country, User } from 'src/core/models'

export const getCompanyDetails = (id: any) => async (dispatch) => {
  try {
    dispatch(reducers.setCompanyDetailsLoading(true))
    const data: Company = await api.getCompanyDetailsAPI(id)
    dispatch(reducers.setCompanyDetailsLoading(false))
    dispatch(reducers.setCompanyDetailsData(data))
  } catch (error) {
    dispatch(reducers.setCompanyDetailsLoading(false))
  }
}

export const editCompanyDetails = (
  id: any, payload: any, getDetails=true,
  user: User = null, countryList: Country[] = null
) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setEditCompanyLoading(true))
    const data: Company = await api.editCompanyAPI(id, payload)
    dispatch(reducers.setEditCompanyLoading(false))
    dispatch(reducers.setEditCompanySuccess(true))
    if (user?.is_business) {
      const countryCode = countryList.find(c => c.id === payload?.country)?.code2
      updateCTCookie('ct-country', countryCode)
    }
    if (getDetails) { dispatch(getCompanyDetails(data?.id)) }
  } catch (error) {
    const vatError = error?.response?.data?.detail
    if (vatError?.length > 0) dispatch(reducers.setEditCompanyError(vatError[0]))
    dispatch(reducers.setEditCompanyLoading(false))
    dispatch(reducers.setEditCompanySuccess(false))
  }
}
